import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}lamy`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const lamyApi = {
  getFilterProductMasterData: (request) => {
    const { config } = request
    return instance().get('/cms/v2/filter-product-master', {
      params: config
    })
  }
}
export default lamyApi



// WEBPACK FOOTER //
// ./src/api/lamy.js